import React from "react"
import config from "../../config"
import { PropTypes } from "prop-types"
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
} from "react-share"

const buttonComponents = {
  Facebook: FacebookShareButton,
  Twitter: TwitterShareButton,
  Email: EmailShareButton,
}
const ShareButtons = ({ sites = [], content }) => {
  return (
    <div>
      {sites.map((platform, i) => {
        const Component = buttonComponents[platform]
        const { icon } = config.socialLinks.find(
          ({ name }) => name === platform
        )

        return (
          <span key={`${i}-share-button`} className="share-button me-3">
            <Component url={content}>
              <i className={icon} />
            </Component>
          </span>
        )
      })}
    </div>
  )
}

ShareButtons.propTypes = {
  sites: PropTypes.array.isRequired,
  content: PropTypes.string.isRequired,
}

export default ShareButtons
